<template>
  <aside class="sidebar-nav" :class="{ 'sidebar-collapsed': isCollapsed }">
    <!-- Logo Section -->
    <div class="sidebar-header">
      <a :href="$store.state.customer_link" class="sidebar-brand">
        <div v-if="logo" class="brand-logo">
          <img :src="logo" alt="Logo" />
        </div>
        <div v-else class="brand-placeholder">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 9.5L12 4L21 9.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 13V19.4C19 19.7314 18.7314 20 18.4 20H5.6C5.26863 20 5 19.7314 5 19.4V13"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </a>
    </div>

    <!-- Navigation Links -->
    <nav class="sidebar-menu">
      <a
        @click="goToProperties"
        class="sidebar-item"
        :class="{
          'is-active':
            $route.name === 'index' || $route.name === 'asset-detail',
        }"
      >
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 9.5L12 4L21 9.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 13V19.4C19 19.7314 18.7314 20 18.4 20H5.6C5.26863 20 5 19.7314 5 19.4V13"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span v-if="!isCollapsed" class="item-label">Mis Propiedades</span>
      </a>

      <router-link
        v-if="opportunitiesPermission"
        :to="{ name: 'opportunities' }"
        class="sidebar-item"
        :class="{ 'is-active': $route.name === 'opportunities' }"
      >
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M16 8L18.29 10.29C18.68 10.68 18.68 11.31 18.29 11.7L13.7 16.29C13.31 16.68 12.68 16.68 12.29 16.29L9.7 13.7C9.31 13.31 8.68 13.31 8.29 13.7L3 19"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21 12V4H13"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span v-if="!isCollapsed" class="item-label">Oportunidades</span>
      </router-link>

      <router-link
        v-if="country == 1 && showQuote"
        :to="{ name: 'quote' }"
        class="sidebar-item"
        :class="{ 'is-active': $route.name === 'quote' }"
      >
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5V19M5 12H19"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span v-if="!isCollapsed" class="item-label">Cotizar</span>
      </router-link>

      <router-link
        v-if="country == 1 && showQuotes"
        :to="{ name: 'myquotes' }"
        class="sidebar-item"
        :class="{ 'is-active': $route.name === 'myquotes' }"
      >
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M9 12H15M9 16H12"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <span v-if="!isCollapsed" class="item-label">Cotizaciones</span>
      </router-link>

      <router-link
        v-if="showMyData"
        :to="{ name: 'information' }"
        class="sidebar-item"
        :class="{ 'is-active': $route.name === 'information' }"
      >
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="8"
              r="4"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M5 20C5 16.6863 7.68629 14 11 14H13C16.3137 14 19 16.6863 19 20"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <span v-if="!isCollapsed" class="item-label">Mi Perfil</span>
      </router-link>
    </nav>

    <!-- Sidebar Footer -->
    <div class="sidebar-footer">
      <button class="sidebar-item logout-item" @click="logout">
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M11 12H4M4 12L7 9M4 12L7 15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span v-if="!isCollapsed" class="item-label">Cerrar Sesión</span>
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: "SidebarNav",
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: this.$auth.user(),
    };
  },
  methods: {
    goToProperties() {
      // Emit event to go back to grid and navigate to index
      this.$root.$emit("go-back-to-grid");
      if (this.$route.name !== "index") {
        this.$router.push({ name: "index" });
      }
    },
    logout() {
      this.$auth.logout({
        redirect: `/app/${this.$route.params.customer}/login`,
        success: function (msg) {
          console.error("LOGIN:", msg);
        },
      });
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    logo() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.logo_1_url
        : null;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    opportunitiesPermission() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Oportunidades"
        ) && this.$store.getters.getCustomerData.show_opportunity
          ? true
          : false;
      } else {
        return false;
      }
    },
    showQuote() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_quote
        : false;
    },
    showQuotes() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_quotes
        : false;
    },
    showMyData() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.show_my_data
        : false;
    },
  },
};
</script>

<style scoped>
/* ===== Sidebar Navigation Styles ===== */
.sidebar-nav {
  --sidebar-width: 260px;
  --sidebar-collapsed-width: 72px;
  --sidebar-bg: #ffffff;
  --sidebar-border: #e5e7eb;
  --sidebar-text: #374151;
  --sidebar-text-muted: #6b7280;
  --sidebar-hover: #f3f4f6;
  --sidebar-active-bg: var(--color-a, #1e40af);
  --sidebar-active-text: var(--color-btn-text, #ffffff);

  width: var(--sidebar-width);
  min-height: 100vh;
  background: var(--sidebar-bg);
  border-right: 1px solid var(--sidebar-border);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  transition: width 0.3s ease;
}

.sidebar-nav.sidebar-collapsed {
  width: var(--sidebar-collapsed-width);
}

/* Header / Logo */
.sidebar-header {
  padding: 16.6px 16px;
  border-bottom: 1px solid var(--sidebar-border);
  display: flex;
  justify-content: center;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: var(--sidebar-text);
}

.sidebar-brand:hover {
  text-decoration: none;
  color: var(--sidebar-text);
}

.brand-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-logo img {
  max-height: 48px;
  max-width: 180px;
  width: auto;
  object-fit: contain;
}

.brand-placeholder {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--sidebar-active-bg);
  border-radius: 12px;
  color: var(--sidebar-active-text);
  flex-shrink: 0;
}

/* Navigation Menu */
.sidebar-menu {
  flex: 1;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  color: var(--sidebar-text-muted);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
}

.sidebar-item:hover {
  background: var(--sidebar-hover);
  color: var(--sidebar-text);
  text-decoration: none;
}

.sidebar-item.is-active {
  background: var(--sidebar-active-bg);
  color: var(--sidebar-active-text);
  font-weight: 600;
}

.sidebar-item.is-active .item-icon {
  color: var(--sidebar-active-text);
}

.item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Footer */
.sidebar-footer {
  padding: 16px 12px;
  border-top: 1px solid var(--sidebar-border);
}

.logout-item {
  color: #dc2626;
}

.logout-item:hover {
  background: #fef2f2;
  color: #dc2626;
}

/* Collapsed State */
.sidebar-collapsed .sidebar-header {
  padding: 20px 12px;
  display: flex;
  justify-content: center;
}

.sidebar-collapsed .sidebar-brand {
  justify-content: center;
}

.sidebar-collapsed .brand-logo img {
  max-width: 40px;
}

.sidebar-collapsed .sidebar-item {
  justify-content: center;
  padding: 12px;
}

.sidebar-collapsed .sidebar-menu,
.sidebar-collapsed .sidebar-footer {
  padding: 16px 8px;
}

/* Responsive */
@media (max-width: 1024px) {
  .sidebar-nav {
    --sidebar-width: 72px;
    width: var(--sidebar-width);
  }

  .brand-name,
  .item-label {
    display: none;
  }

  .sidebar-brand {
    justify-content: center;
  }

  .sidebar-item {
    justify-content: center;
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .sidebar-nav {
    transform: translateX(-100%);
    width: 260px;
  }

  .sidebar-nav.sidebar-open {
    transform: translateX(0);
  }

  .brand-name,
  .item-label {
    display: block;
  }

  .sidebar-brand {
    justify-content: flex-start;
  }

  .sidebar-item {
    justify-content: flex-start;
    padding: 12px 14px;
  }
}
</style>
